<template>
  <div class="spinner">
    <svg class="spinner__svg">
      <circle cx="15" cy="15" r="13"></circle>
    </svg>
  </div>
</template>

<script>
  export default {
    name: "spinner"
  }
</script>

<style lang="scss" scoped>
.spinner {
$spinnerSize: 30;
  z-index: 0;

  svg.spinner__svg {
    width: $spinnerSize + px;
    height: $spinnerSize + px;
    x: 0px;
    y: 0px;
    viewBox: 0 0 $spinnerSize $spinnerSize;

    circle {
      fill: transparent;
      stroke: var(--petco-blue-default);
      stroke-width: 2;
      stroke-linecap: round;
      stroke-dasharray: (3.14 * $spinnerSize);
      transform-origin: (0.5px * $spinnerSize) (0.5px * $spinnerSize) 0;
      animation: spinner 2s linear infinite;
    }

    &--small {
    $size: $spinnerSize / 2;
      width: $size/2 + px;
      height: $size/2 + px;
      viewBox: 0 0 $size $size;

      circle {
        stroke-dasharray: (3.14 * $size);
        transform-origin: (0.5px * $size) (0.5px * $size) 0;
      }
    }
  }

  @-webkit-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      stroke-dashoffset: (0.66 * $spinnerSize);
    } 50% {
        -webkit-transform: rotate(720deg);
        stroke-dashoffset: (3.14 * $spinnerSize);
      } 100% {
          -webkit-transform: rotate(1080deg);
          stroke-dashoffset: (0.66 * $spinnerSize);
        }
  }

  @-moz-keyframes spinner {
    0% {
      -moz-transform: rotate(0deg);
      stroke-dashoffset: (0.66 * $spinnerSize);
    } 50% {
        -moz-transform: rotate(720deg);
        stroke-dashoffset: (3.14 * $spinnerSize);
      } 100% {
          -moz-transform: rotate(1080deg);
          stroke-dashoffset: (0.66 * $spinnerSize);
        }
  }

  @-ms-keyframes spinner {
    0% {
      -ms-transform: rotate(0deg);
      stroke-dashoffset: (0.66 * $spinnerSize);
    } 50% {
        -ms-transform: rotate(720deg);
        stroke-dashoffset: (3.14 * $spinnerSize);
      } 100% {
          -ms-transform: rotate(1080deg);
          stroke-dashoffset: (0.66 * $spinnerSize);
        }
  }

  @-o-keyframes spinner {
    0% {
      -o-transform: rotate(0deg);
      stroke-dashoffset: (0.66 * $spinnerSize);
    } 50% {
        -o-transform: rotate(720deg);
        stroke-dashoffset: (3.14 * $spinnerSize);
      } 100% {
          -o-transform: rotate(1080deg);
          stroke-dashoffset: (0.66 * $spinnerSize);
        }
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
      stroke-dashoffset: (0.66 * $spinnerSize);
    } 50% {
        transform: rotate(720deg);
        stroke-dashoffset: (3.14 * $spinnerSize);
      } 100% {
          transform: rotate(1080deg);
          stroke-dashoffset: (0.66 * $spinnerSize);
        }
  }



}
</style>
